'use client';

import Loading from '@/components/common/Loading';

/**
 * ページローディング
 */
export default function PageLoading() {
  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
      <div className="flex justify-center items-center w-[100px] h-[100px] bg-gray-900 bg-opacity-25 border-0 rounded-lg outline-none focus:outline-none">
        <Loading className="w-8 h-8 me-[0] text-gray-400" />
      </div>
    </div>
  );
}
